export default "__VITE_ASSET__BBOktB_y__ 320w, __VITE_ASSET__WaIVyeMt__ 480w, __VITE_ASSET__Dg3fJb_S__ 640w, __VITE_ASSET__5Rqsowpk__ 800w";